// Shared display taxonomy for the Availability Planner: short code, label, chip colour class
// (see the ap-loc-* / ap-abs-* palette in index.css) and a FontAwesome icon per type.
export const LOCATION = {
  office: { code: 'O', label: 'Office', className: 'ap-loc-office', icon: 'fa-building' },
  home: { code: 'HO', label: 'Home office', className: 'ap-loc-home', icon: 'fa-house' },
  businesstrip: { code: 'BT', label: 'Business trip', className: 'ap-loc-businesstrip', icon: 'fa-plane' },
};

export const ABSENCE = {
  vacation: { code: 'Vac', label: 'Vacation', className: 'ap-abs-vacation', icon: 'fa-umbrella-beach' },
  sick: { code: 'Sick', label: 'Sick leave', className: 'ap-abs-sick', icon: 'fa-kit-medical' },
  unpaid: { code: 'Unpd', label: 'Unpaid', className: 'ap-abs-unpaid', icon: 'fa-money-bill' },
  bankholiday: { code: 'BH', label: 'Bank holiday', className: 'ap-abs-bankholiday', icon: 'fa-landmark' },
  other: { code: 'Oth', label: 'Other', className: 'ap-abs-other', icon: 'fa-ellipsis' },
  toil: { code: 'TOIL', label: 'Time off in lieu', className: 'ap-abs-toil', icon: 'fa-clock-rotate-left' },
};
